export * from './content-header.component';


// WEBPACK FOOTER //
// ./src/app/content/shared/components/content-header/index.ts